import AnalyticsRepository from './AnalyticsRepository';

export * from './AnalyticsRepository';
export default AnalyticsRepository;
